export default __webpack_public_path__ + "static/media/next_platform_image.89a5912f.png";